import HttpService from "./HttpService";
const MODULE_PREFIX = "/payroll";
const API_ENDPOINT = `${MODULE_PREFIX}/create`;

const PayrollService = {
  async generatePayroll(data) {
    try {
      const response = await HttpService.post(API_ENDPOINT, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async regeneratePayroll(id) {
    try {
      const response = await HttpService.post(
        `/payroll/regenerate/${id}`,
        {}
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
    async partialRegeneratePayroll(id) {
    try {
    const response = await HttpService.post(`${MODULE_PREFIX}/partial-regenerate/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getGeneratedPayroll() {
    try {
      const response = await HttpService.get(API_ENDPOINT);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getGeneratedPayrollWithFilters(pageConfig) {
    const pageConfigParams =  new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(`${MODULE_PREFIX}/payroll-paginated?${pageConfigParams}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getNonBudgetPayrollWithFilters(pageConfig) {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(
        `${API_ENDPOINT}/non-budget?${pageConfigParams}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async viewEditPayroll(id) {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/${id}/edit`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getPayrollModes(id) {
    try {
      const response = await HttpService.get(`${MODULE_PREFIX}/list-approved`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getPayrollModesWithFilters(params = {}) {
    const pageConfigParams = new URLSearchParams(params);
    try {
      const response = await HttpService.get(
        `${MODULE_PREFIX}/list-approved?${pageConfigParams}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async viewPayrollAttendanceSheet(id) {
    try {
      const response = await HttpService.get(
        `${API_ENDPOINT}/attendance/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getEmployeeStats() {
    try {
      const response = await HttpService.get(
        `/payroll-dashboard/employee-stats`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getEobiProvident(employeeId) {
    try {
      const response = await HttpService.get(
        `/employee-provident-fund-eobi/${employeeId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getProvidentFundEis(employeeId) {
    const response = await HttpService.get(
      `/employee-provident-fund-eis/${employeeId}`
    );
    return response.data;
  },

  async approvePayroll(id) {
    try {
      const response = await HttpService.post(`${MODULE_PREFIX}/approve/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async generatePayrollSlip(id) {
    try {
      const response = await HttpService.post(
        `${MODULE_PREFIX}/salary-slip/generate/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async publishPayrollSlip(id) {
    try {
      const response = await HttpService.post(
        `${MODULE_PREFIX}/salary-slip/publish/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async generateDepartmentBudget(data) {
    try {
      const response = await HttpService.post(
        "/payroll-dashboard/department-budget",
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async generatePayrollIncentives(data) {
    try {
      const response = await HttpService.post(
        "/payroll-dashboard/incentive",
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async lockPayroll(id) {
    try {
      const response = await HttpService.post(
        `/payroll/lock/${id}`,
        {}
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async unlockPayroll(id) {
    try {
      const response = await HttpService.post(
        `/payroll/unlock/${id}`,
        {}
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async exportBudgetPayroll(type) {
    return HttpService.post(
      `${MODULE_PREFIX}/budget-payroll/export`,
      { type },
      { responseType: "blob", timeout: 0 },
    );
  },
  async exportPayrollCreation(type) {
    return HttpService.post(
      `${MODULE_PREFIX}/payroll-creation/export`,
      { type },
      { responseType: "blob", timeout: 0 },
    );
  },
  async exportPayrollAdjustment(type) {
    return HttpService.post(
      `${MODULE_PREFIX}/payroll-adjustment/export`,
      { type },
      { responseType: "blob", timeout: 0 },
    );
  },
  async exportPendingPayroll(type) {
    return HttpService.post(
      `${MODULE_PREFIX}/pending-payroll/export`,
      { type },
      { responseType: "blob", timeout: 0 },
    );
  },
  async exportApprovedPayroll(type) {
    return HttpService.post(
      `${MODULE_PREFIX}/approved-payroll/export`,
      { type },
      { responseType: "blob", timeout: 0 },
    );
  },
  async exportPaymentModes(type) {
    return HttpService.post(
      `${MODULE_PREFIX}/payment-modes/export`,
      { type },
      { responseType: "blob", timeout: 0 },
    );
  },
};

export default PayrollService;
